export const IiconPosition = {
  LEFT: 'left',
  RIGHT: 'right',
};
